import React from 'react';
import { NewsLoader } from 'modules/shared-cms-advanced/components';
import styles from './actualite-component.module.css';

export const ActualiteLoader: React.FC = React.memo(() => {
    return (
        <div className={`${styles.root} full-width`}>
            <div className={styles.newsContainer}>
                <div className={styles.newsWrapper}>
                    <NewsLoader />
                </div>
                <div className={styles.newsWrapper}>
                    <NewsLoader />
                </div>
                <div className={styles.newsWrapper}>
                    <NewsLoader />
                </div>
            </div>
        </div>
    );
});
